import React, { useState } from 'react';
import VideoModal from '../components/VideoModal';

const CTA = () => {
  const [modalOpen, setModalOpen] = useState(false)

  let toggleModalStatus = (status) => {
    setModalOpen(status)
  }

  return (
    <>
      <section className="cta">
        <div className="cta-content">
          <div className="container">
            <h2>See how our app can help your business.</h2>
            <a href="#contact" className="btn btn-outline btn-xl">
              Watch the video
            </a>
          </div>
        </div>
        <div className="overlay" onClick={() => toggleModalStatus(true)}></div>
      </section>
      <VideoModal modalOpen={modalOpen} toggleModalStatus={toggleModalStatus} />
    </>
  );
};

export default CTA;
